import React, { useEffect, useMemo, useState } from 'react';
import { Container, Form, Button, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const serviceCategories = [
  {
    id: 'electricity',
    name: 'Electricity',
    icon: 'bi-lightning-charge',
    gradient: 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)'
  },
  {
    id: 'water',
    name: 'Water',
    icon: 'bi-droplet-half',
    gradient: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)'
  },
  {
    id: 'gas',
    name: 'Gas',
    icon: 'bi-fire',
    gradient: 'linear-gradient(135deg, #f7971e 0%, #ffd200 100%)'
  },
  {
    id: 'broadband',
    name: 'Broadband',
    icon: 'bi-wifi',
    gradient: 'linear-gradient(135deg, #ff4b2b 0%, #ff416c 100%)'
  },
  {
    id: 'credit-card',
    name: 'Credit Card',
    icon: 'bi-credit-card',
    gradient: 'linear-gradient(135deg, #00c6ff 0%, #0072ff 100%)'
  },
  {
    id: 'loan-emi',
    name: 'Loan EMI',
    icon: 'bi-cash-coin',
    gradient: 'linear-gradient(135deg, #f953c6 0%, #b91d73 100%)'
  },
  {
    id: 'insurance',
    name: 'Insurance',
    icon: 'bi-shield-check',
    gradient: 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)'
  },
  {
    id: 'fastag',
    name: 'FASTag',
    icon: 'bi-truck',
    gradient: 'linear-gradient(135deg, #8e2de2 0%, #4a00e0 100%)'
  },
  {
    id: 'mobile-prepaid',
    name: 'Prepaid',
    icon: 'bi-phone',
    gradient: 'linear-gradient(135deg, #36d1dc 0%, #5b86e5 100%)'
  },
  {
    id: 'mobile-postpaid',
    name: 'Postpaid',
    icon: 'bi-phone-vibrate',
    gradient: 'linear-gradient(135deg, #b24592 0%, #f15f79 100%)'
  },
  {
    id: 'dth',
    name: 'DTH Recharge',
    icon: 'bi-broadcast',
    gradient: 'linear-gradient(135deg, #f77062 0%, #fe5196 100%)'
  },
  {
    id: 'landline',
    name: 'Landline',
    icon: 'bi-telephone',
    gradient: 'linear-gradient(135deg, #00b09b 0%, #96c93d 100%)'
  },
  {
    id: 'municipal-tax',
    name: 'Municipal Tax',
    icon: 'bi-bank',
    gradient: 'linear-gradient(135deg, #6f86d6 0%, #48c6ef 100%)'
  },
  {
    id: 'education-fees',
    name: 'Education',
    icon: 'bi-mortarboard',
    gradient: 'linear-gradient(135deg, #ff9966 0%, #ff5e62 100%)'
  },
  {
    id: 'housing-society',
    name: 'Housing Soc',
    icon: 'bi-buildings',
    gradient: 'linear-gradient(135deg, #8a2387 0%, #e94057 50%, #f27121 100%)'
  },
  {
    id: 'subscription',
    name: 'Subscriptions',
    icon: 'bi-infinity',
    gradient: 'linear-gradient(135deg, #0ba360 0%, #3cba92 100%)'
  },
  {
    id: 'cable-tv',
    name: 'Cable TV',
    icon: 'bi-tv',
    gradient: 'linear-gradient(135deg, #b06ab3 0%, #4568dc 100%)'
  },
  {
    id: 'hospital',
    name: 'Hospital Bi',
    icon: 'bi-hospital',
    gradient: 'linear-gradient(135deg, #f7971e 0%, #ffd200 100%)'
  },
  {
    id: 'club-membership',
    name: 'Club Memb',
    icon: 'bi-people',
    gradient: 'linear-gradient(135deg, #fdc830 0%, #f37335 100%)'
  },
  {
    id: 'challan',
    name: 'Challan Pay',
    icon: 'bi-file-earmark-text',
    gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
  }
];

const stateOptions = [
  { value: 'delhi', label: 'Delhi' },
  { value: 'maharashtra', label: 'Maharashtra' },
  { value: 'karnataka', label: 'Karnataka' },
  { value: 'uttar-pradesh', label: 'Uttar Pradesh' },
  { value: 'pan-india', label: 'Pan India' }
];

const operatorCatalog = {
  electricity: [
    {
      label: 'BSES Rajdhani',
      value: 'bses-rajdhani',
      logo: 'https://logo.clearbit.com/bsesdelhi.com',
      states: ['delhi']
    },
    {
      label: 'Tata Power Mumbai',
      value: 'tata-power',
      logo: 'https://logo.clearbit.com/tatapower.com',
      states: ['maharashtra']
    },
    {
      label: 'Adani Electricity',
      value: 'adani-electricity',
      logo: 'https://logo.clearbit.com/adanielectricity.com',
      states: ['maharashtra', 'pan-india']
    },
    {
      label: 'UPPCL Urban',
      value: 'uppcl-urban',
      logo: 'https://logo.clearbit.com/uppcl.org',
      states: ['uttar-pradesh']
    }
  ],
  water: [
    {
      label: 'Delhi Jal Board',
      value: 'delhi-jal-board',
      logo: 'https://logo.clearbit.com/djb.gov.in',
      states: ['delhi']
    },
    {
      label: 'Bangalore Water Supply',
      value: 'bwssb',
      logo: 'https://logo.clearbit.com/bwssb.gov.in',
      states: ['karnataka']
    }
  ],
  gas: [
    {
      label: 'Indane Gas',
      value: 'indane',
      logo: 'https://logo.clearbit.com/indane.co.in',
      states: ['pan-india']
    },
    {
      label: 'HP Gas',
      value: 'hp-gas',
      logo: 'https://logo.clearbit.com/myhpgas.in',
      states: ['pan-india']
    },
    {
      label: 'Bharat Gas',
      value: 'bharat-gas',
      logo: 'https://logo.clearbit.com/ebharatgas.com',
      states: ['pan-india']
    }
  ],
  broadband: [
    {
      label: 'Airtel Xstream Fiber',
      value: 'airtel-broadband',
      logo: 'https://logo.clearbit.com/airtel.in',
      states: ['pan-india']
    },
    {
      label: 'Jio Fiber',
      value: 'jio-fiber',
      logo: 'https://logo.clearbit.com/jio.com',
      states: ['pan-india']
    },
    {
      label: 'BSNL Broadband',
      value: 'bsnl-broadband',
      logo: 'https://logo.clearbit.com/bsnl.co.in',
      states: ['pan-india']
    }
  ],
  'credit-card': [
    {
      label: 'HDFC Bank Credit Card',
      value: 'hdfc-cc',
      logo: 'https://logo.clearbit.com/hdfcbank.com',
      states: ['pan-india']
    },
    {
      label: 'ICICI Bank Credit Card',
      value: 'icici-cc',
      logo: 'https://logo.clearbit.com/icicibank.com',
      states: ['pan-india']
    },
    {
      label: 'Axis Bank Credit Card',
      value: 'axis-cc',
      logo: 'https://logo.clearbit.com/axisbank.com',
      states: ['pan-india']
    }
  ],
  'loan-emi': [
    {
      label: 'HDFC Loans',
      value: 'hdfc-loan',
      logo: 'https://logo.clearbit.com/hdfcbank.com',
      states: ['pan-india']
    },
    {
      label: 'Bajaj Finserv',
      value: 'bajaj-finserv',
      logo: 'https://logo.clearbit.com/bajajfinserv.in',
      states: ['pan-india']
    },
    {
      label: 'Hero Fincorp',
      value: 'hero-fincorp',
      logo: 'https://logo.clearbit.com/herofincorp.com',
      states: ['pan-india']
    }
  ],
  insurance: [
    {
      label: 'LIC of India',
      value: 'lic',
      logo: 'https://logo.clearbit.com/licindia.in',
      states: ['pan-india']
    },
    {
      label: 'HDFC Life',
      value: 'hdfc-life',
      logo: 'https://logo.clearbit.com/hdfclife.com',
      states: ['pan-india']
    },
    {
      label: 'SBI Life',
      value: 'sbi-life',
      logo: 'https://logo.clearbit.com/sbilife.co.in',
      states: ['pan-india']
    }
  ],
  fastag: [
    {
      label: 'ICICI FASTag',
      value: 'icici-fastag',
      logo: 'https://logo.clearbit.com/icicibank.com',
      states: ['pan-india']
    },
    {
      label: 'HDFC FASTag',
      value: 'hdfc-fastag',
      logo: 'https://logo.clearbit.com/hdfcbank.com',
      states: ['pan-india']
    },
    {
      label: 'Paytm FASTag',
      value: 'paytm-fastag',
      logo: 'https://logo.clearbit.com/paytm.com',
      states: ['pan-india']
    }
  ],
  'mobile-prepaid': [
    {
      label: 'Airtel Prepaid',
      value: 'airtel-prepaid',
      logo: 'https://logo.clearbit.com/airtel.in',
      states: ['pan-india']
    },
    {
      label: 'Jio Prepaid',
      value: 'jio-prepaid',
      logo: 'https://logo.clearbit.com/jio.com',
      states: ['pan-india']
    },
    {
      label: 'Vi Prepaid',
      value: 'vi-prepaid',
      logo: 'https://logo.clearbit.com/myvi.in',
      states: ['pan-india']
    }
  ],
  'mobile-postpaid': [
    {
      label: 'Airtel Postpaid',
      value: 'airtel-postpaid',
      logo: 'https://logo.clearbit.com/airtel.in',
      states: ['pan-india']
    },
    {
      label: 'Jio Postpaid',
      value: 'jio-postpaid',
      logo: 'https://logo.clearbit.com/jio.com',
      states: ['pan-india']
    },
    {
      label: 'Vi Postpaid',
      value: 'vi-postpaid',
      logo: 'https://logo.clearbit.com/myvi.in',
      states: ['pan-india']
    }
  ],
  dth: [
    {
      label: 'Tata Play',
      value: 'tata-play',
      logo: 'https://logo.clearbit.com/tataplay.com',
      states: ['pan-india']
    },
    {
      label: 'Dish TV',
      value: 'dish-tv',
      logo: 'https://logo.clearbit.com/dishtv.in',
      states: ['pan-india']
    },
    {
      label: 'Airtel DTH',
      value: 'airtel-dth',
      logo: 'https://logo.clearbit.com/airtel.in',
      states: ['pan-india']
    }
  ],
  landline: [
    {
      label: 'BSNL Landline',
      value: 'bsnl-landline',
      logo: 'https://logo.clearbit.com/bsnl.co.in',
      states: ['pan-india']
    },
    {
      label: 'Airtel Landline',
      value: 'airtel-landline',
      logo: 'https://logo.clearbit.com/airtel.in',
      states: ['pan-india']
    }
  ],
  'municipal-tax': [
    {
      label: 'MCD Property Tax',
      value: 'mcd-tax',
      logo: 'https://logo.clearbit.com/mcdonline.nic.in',
      states: ['delhi']
    },
    {
      label: 'BBMP Property Tax',
      value: 'bbmp-tax',
      logo: 'https://logo.clearbit.com/bbmp.gov.in',
      states: ['karnataka']
    }
  ],
  'education-fees': [
    {
      label: 'Delhi Public School',
      value: 'dps-school',
      logo: 'https://logo.clearbit.com/dpsrohini.com',
      states: ['delhi']
    },
    {
      label: 'Manipal University',
      value: 'manipal-university',
      logo: 'https://logo.clearbit.com/manipal.edu',
      states: ['pan-india']
    }
  ],
  'housing-society': [
    {
      label: 'Lodha Society',
      value: 'lodha-society',
      logo: 'https://logo.clearbit.com/lodhagroup.in',
      states: ['maharashtra']
    },
    {
      label: 'Prestige Lakeside Habitat',
      value: 'prestige-habitat',
      logo: 'https://logo.clearbit.com/prestigegroup.com',
      states: ['karnataka']
    }
  ],
  subscription: [
    {
      label: 'Netflix',
      value: 'netflix-subscription',
      logo: 'https://logo.clearbit.com/netflix.com',
      states: ['pan-india']
    },
    {
      label: 'Amazon Prime',
      value: 'amazon-prime',
      logo: 'https://logo.clearbit.com/primevideo.com',
      states: ['pan-india']
    }
  ],
  'cable-tv': [
    {
      label: 'Hathway Cable',
      value: 'hathway-cable',
      logo: 'https://logo.clearbit.com/hathway.com',
      states: ['pan-india']
    },
    {
      label: 'DEN Networks',
      value: 'den-cable',
      logo: 'https://logo.clearbit.com/dennetworks.com',
      states: ['pan-india']
    }
  ],
  hospital: [
    {
      label: 'Fortis Hospital',
      value: 'fortis-hospital',
      logo: 'https://logo.clearbit.com/fortishealthcare.com',
      states: ['pan-india']
    },
    {
      label: 'Apollo Hospitals',
      value: 'apollo-hospital',
      logo: 'https://logo.clearbit.com/apollohospitals.com',
      states: ['pan-india']
    }
  ],
  'club-membership': [
    {
      label: 'DLF Club 5',
      value: 'dlf-club',
      logo: 'https://logo.clearbit.com/dlf.in',
      states: ['pan-india']
    },
    {
      label: 'Bangalore Club',
      value: 'bangalore-club',
      logo: 'https://logo.clearbit.com/bangaloreclub.com',
      states: ['karnataka']
    }
  ],
  challan: [
    {
      label: 'Delhi Traffic Challan',
      value: 'delhi-challan',
      logo: 'https://logo.clearbit.com/dtptraffic.delhi.gov.in',
      states: ['delhi']
    },
    {
      label: 'Maharashtra E-Challan',
      value: 'maharashtra-challan',
      logo: 'https://logo.clearbit.com/mahapolice.gov.in',
      states: ['maharashtra']
    }
  ]
};

const initialFormState = {
  consumerId: '',
  customerName: '',
  mobileNumber: '',
  email: '',
  billAmount: '',
  dueDate: '',
  remarks: ''
};

const BillPaymentServices = () => {
  const navigate = useNavigate();
  const [selectedService, setSelectedService] = useState(serviceCategories[0]);
  const [selectedState, setSelectedState] = useState('');
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [selectionError, setSelectionError] = useState('');
  const [showDetailsCard, setShowDetailsCard] = useState(false);
  const [formData, setFormData] = useState(initialFormState);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [consumerInput, setConsumerInput] = useState('');
  const [consumerError, setConsumerError] = useState('');
  const [showOverflowMenu, setShowOverflowMenu] = useState(false);
  const [isMobileView, setIsMobileView] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth <= 576 : false
  );
  const [visibleServiceCount, setVisibleServiceCount] = useState(5);

  const primaryServices = serviceCategories.slice(0, 13);
  const overflowServices = serviceCategories.slice(13);
  const isOverflowActive = !isMobileView && overflowServices.some((service) => service.id === selectedService?.id);
  const mobileServices = serviceCategories.slice(0, Math.min(visibleServiceCount, serviceCategories.length));
  const servicesToDisplay = isMobileView ? mobileServices : primaryServices;
  const hasMoreMobileServices = isMobileView && visibleServiceCount < serviceCategories.length;

  const availableOperators = useMemo(() => {
    if (!selectedService) {
      return [];
    }

    const options = operatorCatalog[selectedService.id] || [];
    if (!selectedState) {
      return options;
    }

    return options.filter((operator) => {
      if (!operator.states || operator.states.length === 0) {
        return true;
      }
      return operator.states.includes(selectedState) || operator.states.includes('pan-india');
    });
  }, [selectedService, selectedState]);

  const resetSelections = () => {
    setSelectedState('');
    setSelectedOperator(null);
    setSelectionError('');
    setShowDetailsCard(false);
    setFormData(initialFormState);
    setErrors({});
    setConsumerInput('');
    setConsumerError('');
    setIsSubmitting(false);
  };

  const handleServiceSelect = (service) => {
    setSelectedService(service);
    resetSelections();
    setShowOverflowMenu(false);
  };

  const handleStateChange = (event) => {
    setSelectedState(event.target.value);
    setSelectedOperator(null);
    setSelectionError('');
    setShowDetailsCard(false);
  };

  const handleOperatorSelect = (operator) => {
    setSelectedOperator(operator);
    setSelectionError('');
  };

  const handleOperatorChange = (event) => {
    const value = event.target.value;
    if (!value) {
      setSelectedOperator(null);
      return;
    }
    const operator = availableOperators.find((item) => item.value === value) || null;
    handleOperatorSelect(operator);
  };

  const handleOperatorContinue = () => {
    if (!selectedState) {
      setSelectionError('Please select a state');
      return;
    }

    if (!selectedOperator) {
      setSelectionError('Please select an operator');
      return;
    }

    if (!consumerInput.trim()) {
      setConsumerError('Consumer / Account number is required');
      return;
    }

    setSelectionError('');
    setConsumerError('');

    const dueDate = new Date();
    dueDate.setDate(dueDate.getDate() + 7);
    const formattedDueDate = dueDate.toISOString().split('T')[0];

    setFormData((prev) => ({
      ...prev,
      consumerId: consumerInput,
      customerName: prev.customerName || 'Amit Kumar',
      mobileNumber: prev.mobileNumber || '9876543210',
      billAmount: prev.billAmount || '1250',
      dueDate: prev.dueDate || formattedDueDate
    }));
    setShowDetailsCard(true);
  };

  const handleFormChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const validationErrors = {};

    if (!formData.consumerId.trim()) {
      validationErrors.consumerId = 'Consumer / Account number is required';
    }

    if (!formData.customerName.trim()) {
      validationErrors.customerName = 'Customer name is required';
    }

    if (!formData.mobileNumber.trim()) {
      validationErrors.mobileNumber = 'Registered mobile number is required';
    } else if (!/^\d{10}$/.test(formData.mobileNumber.trim())) {
      validationErrors.mobileNumber = 'Enter a valid 10 digit mobile number';
    }

    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) {
      validationErrors.email = 'Enter a valid email address';
    }

    if (!formData.billAmount) {
      validationErrors.billAmount = 'Bill amount is required';
    } else if (Number.isNaN(Number(formData.billAmount)) || Number(formData.billAmount) <= 0) {
      validationErrors.billAmount = 'Enter a valid amount greater than zero';
    }

    if (!formData.dueDate) {
      validationErrors.dueDate = 'Due date is mandatory';
    }

    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  const handleValidateAndContinue = () => {
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    const stateLabel = stateOptions.find((option) => option.value === selectedState)?.label || '';

    navigate('/bill-payments/payment', {
      state: {
        service: selectedService,
        operator: selectedOperator,
        region: stateLabel,
        billDetails: formData
      }
    });
  };

  useEffect(() => {
    if (!showOverflowMenu) {
      return undefined;
    }

    const handleClickOutside = (event) => {
      const target = event.target;
      if (target instanceof Element && target.closest('.service-overflow-wrapper')) {
        return;
      }
      setShowOverflowMenu(false);
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showOverflowMenu]);

  useEffect(() => {
    const handleResize = () => {
      if (typeof window === 'undefined') {
        return;
      }
      setIsMobileView(window.innerWidth <= 576);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (isMobileView) {
      setShowOverflowMenu(false);
      setVisibleServiceCount((prev) => Math.max(prev, 5));
    } else {
      setVisibleServiceCount(5);
    }
  }, [isMobileView]);

  return (
    <Container fluid className="bill-payments-services p-4">
      <div className="page-header mb-4">
        <h4 className="mb-1" style={{ fontWeight: 600, color: '#2c2268' }}>
          <i className="bi bi-receipt-cutoff me-2"></i>
          Bill Payments
        </h4>
        <h6 className="text-muted mb-0">
          Choose a service to get started with secure and instant bill payments.
        </h6>
      </div>

      <div className="service-strip">
        <div className="service-row">
          {servicesToDisplay.map((service) => {
            const isActive = selectedService?.id === service.id;
            return (
              <button
                key={service.id}
                type="button"
                className={`service-item ${isActive ? 'active' : ''}`}
                onClick={() => handleServiceSelect(service)}
              >
                <div
                  className="service-icon-wrapper"
                  style={{ background: service.gradient }}
                >
                  <i className={`bi ${service.icon}`}></i>
                </div>
                <span className="service-name">{service.name}</span>
              </button>
            );
          })}
          {isMobileView ? (
            hasMoreMobileServices ? (
              <button
                type="button"
                className="service-item service-item--mobile-more"
                onClick={() =>
                  setVisibleServiceCount((prev) => Math.min(prev + 5, serviceCategories.length))
                }
              >
                <div className="service-icon-wrapper more-icon-wrapper">
                  <i className="bi bi-plus-lg"></i>
                </div>
                <span className="service-name">More</span>
              </button>
            ) : null
          ) : overflowServices.length ? (
            <div className="service-overflow-wrapper">
              <button
                type="button"
                className={`service-item ${isOverflowActive ? 'active' : ''}`}
                onClick={(event) => {
                  event.stopPropagation();
                  setShowOverflowMenu((prev) => !prev);
                }}
                aria-haspopup="true"
                aria-expanded={showOverflowMenu}
              >
                <div className="service-icon-wrapper more-icon-wrapper">
                  <i className="bi bi-three-dots"></i>
                </div>
                <span className="service-name">More</span>
              </button>
              {showOverflowMenu ? (
                <div className="overflow-menu">
                  {overflowServices.map((service) => {
                    const isActive = selectedService?.id === service.id;
                    return (
                      <button
                        key={service.id}
                        type="button"
                        className={`overflow-item ${isActive ? 'active' : ''}`}
                        onClick={() => handleServiceSelect(service)}
                      >
                        <span className="overflow-item__name">{service.name}</span>
                      </button>
                    );
                  })}
                </div>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>

      {selectedService ? (
        <div className="selection-layout">
          <Card className="selection-card shadow-sm">
            <Card.Body>
              <div className="selection-header">
                <div className="selection-header__content">
                  <div className="selection-header__icon" style={{ background: selectedService.gradient }}>
                    <i className={`bi ${selectedService.icon}`}></i>
                  </div>
                  <div>
                    <p className="mb-0 selection-label">Selected service</p>
                    <h6 className="mb-0 selection-name">{selectedService.name}</h6>
                  </div>
                </div>
                <img src="/b_assured.png" alt="B Assured" className="brand-badge" />
              </div>

              <Form.Group className="mt-4">
                <Form.Label className="selector-label">Select state</Form.Label>
                <Form.Select value={selectedState} onChange={handleStateChange}>
                  <option value="">Choose state</option>
                  {stateOptions.map((state) => (
                    <option key={state.value} value={state.value}>
                      {state.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <div className="operator-list">
                {availableOperators.length > 0 ? (
                  <>
                    <Form.Label className="selector-label mt-2">Select operator</Form.Label>
                    <Form.Select
                      value={selectedOperator?.value || ''}
                      onChange={handleOperatorChange}
                      className="operator-select"
                    >
                      <option value="">Choose operator</option>
                      {availableOperators.map((operator) => (
                        <option key={operator.value} value={operator.value}>
                          {operator.label}
                        </option>
                      ))}
                    </Form.Select>

                    {selectedOperator ? (
                      <div className="operator-preview mt-3">
                        <div className="operator-avatar operator-avatar--compact">
                          <img
                            src={selectedOperator.logo}
                            alt={selectedOperator.label}
                            onError={(event) => {
                              event.currentTarget.onerror = null;
                              event.currentTarget.src = `https://via.placeholder.com/44/002f74/ffffff?text=${selectedOperator.label.charAt(0)}`;
                            }}
                          />
                        </div>
                        <div className="operator-meta">
                          <span className="operator-name">{selectedOperator.label}</span>
                          {selectedOperator.states?.length ? (
                            <span className="operator-region">
                              {selectedOperator.states.includes('pan-india')
                                ? 'Pan India'
                                : selectedOperator.states
                                    .map((stateCode) => stateOptions.find((state) => state.value === stateCode)?.label || stateCode)
                                    .join(', ')}
                            </span>
                          ) : null}
                        </div>
                      </div>
                    ) : null}

                    <Form.Group className="mt-3">
                      <Form.Label className="selector-label">Consumer / Account Number</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter consumer number"
                        value={consumerInput}
                        onChange={(event) => {
                          setConsumerInput(event.target.value);
                          if (consumerError) {
                            setConsumerError('');
                          }
                        }}
                        isInvalid={!!consumerError}
                      />
                      <Form.Control.Feedback type="invalid">{consumerError}</Form.Control.Feedback>
                    </Form.Group>
                  </>
                ) : (
                  <div className="operator-empty">
                    <i className="bi bi-exclamation-circle me-2"></i>
                    No operators available for the selected state.
                  </div>
                )}
              </div>

              {selectionError ? (
                <div className="selection-error">
                  <i className="bi bi-exclamation-triangle me-2"></i>
                  {selectionError}
                </div>
              ) : null}

              <Button
                className="btn-outline-primary-custom w-100 mt-3"
                onClick={handleOperatorContinue}
              >
                Continue
              </Button>
            </Card.Body>
          </Card>

          {showDetailsCard && selectedOperator ? (
            <Card className="details-card shadow-sm">
              <Card.Body>
                <div className="details-header">
                  <div className="details-header__info">
                    <div className="operator-avatar operator-avatar--header">
                      <img
                        src={selectedOperator?.logo}
                        alt={selectedOperator?.label || 'Operator'}
                        onError={(event) => {
                          event.currentTarget.onerror = null;
                          event.currentTarget.src = `https://via.placeholder.com/48/002f74/ffffff?text=${selectedOperator?.label?.charAt(0) || 'O'}`;
                        }}
                      />
                    </div>
                    <div>
                      <p className="mb-0 selection-label">Bill details for</p>
                      <h6 className="mb-1 selection-name">{selectedOperator?.label}</h6>
                      <small className="text-muted">
                        Region: {stateOptions.find((state) => state.value === selectedState)?.label || 'N/A'}
                      </small>
                    </div>
                  </div>
                  <img src="/b_assured.png" alt="B Assured" className="brand-badge brand-badge--details" />
                </div>
                <div className="details-summary mt-4">
                  <div className="details-item">
                    <span className="details-label">Consumer / Account Number</span>
                    <span className="details-value">{formData.consumerId}</span>
                  </div>
                  <div className="details-item">
                    <span className="details-label">Customer Name</span>
                    <span className="details-value">{formData.customerName}</span>
                  </div>
                  <div className="details-item">
                    <span className="details-label">Registered Mobile</span>
                    <span className="details-value">+91 {formData.mobileNumber}</span>
                  </div>
                  <div className="details-item">
                    <span className="details-label">Bill Amount</span>
                    <span className="details-value">₹{Number(formData.billAmount || 0).toLocaleString('en-IN')}</span>
                  </div>
                  <div className="details-item">
                    <span className="details-label">Due Date</span>
                    <span className="details-value">
                      {formData.dueDate
                        ? new Date(formData.dueDate).toLocaleDateString('en-IN', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric'
                          })
                        : 'Not available'}
                    </span>
                  </div>
                </div>

                <Button
                  size="lg"
                  disabled={isSubmitting}
                  className="primary-action-btn w-100 mt-3"
                  onClick={handleValidateAndContinue}
                >
                  {isSubmitting ? 'Processing...' : 'Pay Now'}
                </Button>
              </Card.Body>
            </Card>
          ) : null}
        </div>
      ) : null}

      <style jsx="true">{`
        .bill-payments-services {
          background-color: #f8f9fc;
          min-height: calc(100vh - 100px);
        }

        .service-strip {
          background: transparent;
          border-radius: 18px;
          padding: 8px 16px;
          overflow: visible;
        }

        .service-strip::-webkit-scrollbar,
        .service-row::-webkit-scrollbar {
          display: none;
        }

        .service-strip {
          scrollbar-width: none;
        }

        .service-row {
          display: grid;
          grid-template-columns: repeat(14, minmax(0, 1fr));
          align-items: center;
          gap: 16px;
        }

        .service-item {
          border: none;
          background: transparent;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
          color: #27426b;
          cursor: pointer;
          position: relative;
          padding: 4px 6px 8px;
          transition: transform 0.3s ease, color 0.3s ease;
          min-width: 0;
        }

        .service-overflow-wrapper {
          position: relative;
          display: flex;
          justify-content: center;
        }

        .service-icon-wrapper {
          width: 44px;
          height: 44px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          font-size: 20px;
          box-shadow: 0 8px 18px rgba(0, 0, 0, 0.15);
        }

        .more-icon-wrapper {
          background: rgba(30, 24, 80, 0.12);
          color: #1e1850;
        }

        .service-name {
          font-size: 12px;
          font-weight: 600;
          color: inherit;
          transition: color 0.3s ease;
          white-space: nowrap;
        }

        .service-item:hover {
          transform: translateY(-4px);
          color: #1e295d;
        }

        .service-item.active {
          color: #0e8cff;
        }

        .service-item.active::after {
          content: '';
          position: absolute;
          bottom: 0;
          width: 24px;
          height: 2px;
          background: #0e8cff;
          border-radius: 999px;
        }

        .overflow-menu {
          position: absolute;
          top: calc(100% + 10px);
          right: 0;
          background: #ffffff;
          border-radius: 16px;
          box-shadow: 0 18px 45px rgba(30, 24, 80, 0.18);
          padding: 12px;
          min-width: 220px;
          display: flex;
          flex-direction: column;
          gap: 8px;
          z-index: 20;
        }

        .overflow-item {
          border: none;
          background: transparent;
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 10px 14px;
          border-radius: 12px;
          cursor: pointer;
          transition: background-color 0.3s ease, transform 0.3s ease;
          color: #27426b;
          text-align: left;
        }

        .overflow-item:hover {
          background: rgba(14, 140, 255, 0.08);
          transform: translateX(4px);
        }

        .overflow-item.active {
          background: rgba(14, 140, 255, 0.16);
          color: #0e8cff;
        }

        .overflow-item__name {
          font-size: 13px;
          font-weight: 600;
        }

        .selection-layout {
          display: flex;
          gap: 24px;
          margin-top: 28px;
          align-items: flex-start;
          flex-wrap: wrap;
        }

        .selection-card {
          flex: 0 0 460px;
          max-width: 480px;
          border-radius: 16px;
          padding: 16px 22px;
        }

        .selection-card .mb-3 {
          margin-bottom: 0 !important;
        }

        .selection-card .mt-4 {
          margin-top: 10px !important;
        }

        .selection-card .mt-3 {
          margin-top: 8px !important;
        }

        .details-card {
          flex: 0 0 460px;
          max-width: 500px;
          border-radius: 16px;
          min-width: 320px;
          padding: 18px 24px;
        }

        .selection-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          margin-bottom: 6px;
        }

        .selection-header__content {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .selection-header__icon {
          width: 44px;
          height: 44px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 20px;
          box-shadow: 0 8px 18px rgba(0, 0, 0, 0.15);
        }

        .selection-label {
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          color: #6c757d;
        }

        .selection-name {
          font-weight: 700;
          color: #2c2268;
        }

        .selector-label {
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          color: #6c757d;
        }

        .operator-list {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .operator-avatar {
          width: 44px;
          height: 44px;
          border-radius: 10px;
          overflow: hidden;
          background: rgba(0, 47, 116, 0.08);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .operator-avatar img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .operator-avatar--compact {
          width: 48px;
          height: 48px;
        }

        .operator-avatar--header {
          width: 52px;
          height: 52px;
        }

        .operator-meta {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 2px;
        }

        .operator-name {
          font-weight: 600;
          color: #1e295d;
          font-size: 14px;
        }

        .operator-region {
          font-size: 11px;
          color: #6c757d;
        }

        .operator-select {
          height: 44px;
          font-size: 14px;
        }

        .operator-preview {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 8px 10px;
          border: 1px solid rgba(0, 0, 0, 0.08);
          border-radius: 12px;
          background: rgba(14, 140, 255, 0.05);
        }

        .operator-empty {
          border: 1px dashed rgba(0, 0, 0, 0.1);
          border-radius: 14px;
          padding: 16px;
          color: #6c757d;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
        }

        .selection-error {
          margin-top: 16px;
          padding: 10px 14px;
          border-radius: 12px;
          background: rgba(255, 193, 7, 0.1);
          color: #856404;
          font-weight: 600;
          font-size: 13px;
        }

        .details-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
        }

        .details-header__info {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .details-header__info > div:last-child {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }

        .brand-badge {
          width: 48px;
          height: 48px;
          object-fit: contain;
        }

        .brand-badge--details {
          width: 56px;
          height: 56px;
        }

        .primary-action-btn {
          background-color: transparent;
          color: #1e1850;
          border: 1px solid #1e1850;
          border-radius: 12px;
          font-weight: 600;
          padding: 12px 32px;
          transition: background-color 0.3s ease, color 0.3s ease, box-shadow 0.3s ease;
        }

        .primary-action-btn:hover,
        .primary-action-btn:focus {
          background-color: #1e1850;
          color: #ffffff;
          box-shadow: 0 12px 22px rgba(30, 24, 80, 0.25);
        }

        .primary-action-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          box-shadow: none;
        }

        .details-summary {
          display: flex;
          flex-direction: column;
          gap: 4px;
          padding: 4px 0;
        }

        .details-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 16px;
          padding: 6px 0;
          border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        }

        .details-item:last-child {
          border-bottom: none;
        }

        .details-label {
          font-size: 14px;
          color: #4a5568;
          font-weight: 600;
        }

        .details-value {
          font-size: 14px;
          font-weight: 600;
          color:rgb(14, 14, 15);
          text-align: right;
        }

        @media (max-width: 1200px) {
          .service-strip {
            overflow-x: auto;
          }

          .service-row {
            display: flex;
            gap: 12px;
          }

          .service-item {
            min-width: 72px;
          }
        }

        @media (max-width: 992px) {
          .service-strip {
            padding: 8px 12px;
          }

          .selection-layout {
            flex-direction: column;
          }

          .selection-card,
          .details-card {
            flex: 1 1 100%;
            max-width: 100%;
            padding: 16px;
          }

          .operator-preview {
            padding: 10px;
          }
        }

        @media (max-width: 576px) {
          .bill-payments-services {
            padding: 12px 12px 32px !important;
          }

          .service-strip {
            border-radius: 14px;
            padding: 10px 6px;
            margin: 0;
            overflow: visible;
            margin-bottom: 16px;
          }

          .service-row {
            display: grid;
            grid-template-columns: repeat(5, minmax(0, 1fr));
            gap: 12px 8px;
            justify-items: center;
          }

          .service-item {
            width: 100%;
            max-width: 74px;
            padding: 6px 4px 10px;
          }

          .service-icon-wrapper {
            width: 40px;
            height: 40px;
            font-size: 18px;
          }

          .service-item--mobile-more .service-name {
            color: #1e1850;
          }

          .service-item--mobile-more .service-icon-wrapper {
            background: rgba(30, 24, 80, 0.12);
            color: #1e1850;
            box-shadow: none;
          }

          .selection-layout {
            gap: 18px;
            margin-top: 20px;
          }

          .selection-card,
          .details-card {
            flex: 1 1 100%;
            max-width: 100%;
            width: 100%;
            margin: 0;
            border-radius: 14px;
            padding: 16px 18px;
            box-shadow: 0 10px 28px rgba(30, 24, 80, 0.08);
          }

          .selection-card .mt-4 {
            margin-top: 12px !important;
          }

          .operator-preview {
            padding: 12px;
          }

          .service-overflow-wrapper {
            display: none;
          }
        }
      `}</style>
    </Container>
  );
};

export default BillPaymentServices;


